module.exports = __webpack_public_path__ + "static/TW-2-f182e0b8722a026ea1f2ca573183e4c8.png";